import React, { useEffect, useState } from 'react';
import './index.scss';
import * as API from '../../configuration/apiconfig';

const DeliveryType = props => {
  const [selectedDeliveryType, setSelectedDeliveryType] = useState(null);

  const { fnbDataForTicketSummary, handleDeliveryTypeSelection, isLoading, isPickupAvailable, deliveryTypeError, forcePickupSelection } = props;
  const pickupOnly = isPickupAvailable?.[0]?.pickup === true || forcePickupSelection;
  const showPickupDrawerBeforeBookingSelection = window.constant.SHOW_DELIVERY_TYPE_DRAWER_BEFORE_BOOKING_SELECTION_DRAWER;
  const fnbDeliveryFee = window.constant.FNB_DELIVERY_FEE;

  useEffect(() => {
    if (pickupOnly) {
      setSelectedDeliveryType('pickup');
    } else if (isPickupAvailable?.length === 0) {
      setSelectedDeliveryType(null);
    }
  }, [pickupOnly, isPickupAvailable]);

  return (
    <div>
      <section className="delivery-type-container">
        <p className="delivery-type-description">
          {deliveryTypeError || (pickupOnly
            ? 'Sorry! The items are currently available for pickup at concession counter only.'
            : showPickupDrawerBeforeBookingSelection ? 'How would you like to receive your order?' : 'Some menu items can be delivered to your seat, while others must be picked up from the concessions counter')}
        </p>
        <div className={`delivery-type-card to-be-picked-up ${selectedDeliveryType === 'pickup' ? 'active' : ''}`} role="button" onClick={() => setSelectedDeliveryType('pickup')}>
          <div className="delivery-type-card-header">
            <img src={selectedDeliveryType === 'pickup' ? '/assets/images/to-be-picked-up-active.png' : '/assets/images/to-be-picked-up.png'} alt="" className="delivery-type-image" />
            <p className="delivery-type-label">Picked Up at the Concessions Counter</p>
          </div>
          <div className="delivery-type-card-content">

            {
              showPickupDrawerBeforeBookingSelection ?
                <>
                  <p className="delivery-note to-be-picked-up">All items will be available after being prepared</p>
                </>
                :
                <>
                  <p className="delivery-note to-be-picked-up">- All items will be ready immediately -</p>
                  <ul className="to-be-picked-up-items-list" style={{ '--list-item-icon': "url('/assets/images/pick-up-list-item-icon.png')" }}>
                    {fnbDataForTicketSummary?.map(item => {
                      return (
                        <li className="pickup">
                          <span>{item.description}</span>
                          <span>x{item.qty}</span>
                        </li>
                      );
                    })}
                  </ul>
                </>
            }
          </div>
        </div>

        <div className={`delivery-type-card in-seat-delivery ${selectedDeliveryType === 'inSeatDelivery' ? 'active' : ''}${pickupOnly ? 'disableDelivery' : ''}`}
          role="button"
          onClick={() => !pickupOnly && setSelectedDeliveryType('inSeatDelivery')}
        >
          <div className="delivery-type-card-header">
            <img src={selectedDeliveryType === 'inSeatDelivery' ? '/assets/images/in-seat-delivery-active.png' : '/assets/images/in-seat-delivery.png'} alt="" className="delivery-type-image" />
            <p className="delivery-type-label">{showPickupDrawerBeforeBookingSelection ? "Deliver to your Seat" : "Deliver to your Seat"}</p>
          </div>
          <div className="delivery-type-card-content">

            {
              showPickupDrawerBeforeBookingSelection ?
                <>
                  <p className="delivery-note in-seat-delivery">We will bring your items to your seat when they are ready</p>
                  {
                    fnbDeliveryFee &&
                    <p className='delivery-fee'>+ ${fnbDeliveryFee} Delivery Fee</p>
                  }
                </>
                :
                <>
                  <p className="delivery-note in-seat-delivery">- Delivered to your seat -</p>
                  <ul className="in-seat-delivery-items-list" style={{ '--list-item-icon': "url('/assets/images/in-seat-list-item-icon.png')" }}>
                    {fnbDataForTicketSummary
                      ?.filter(item => item.inSeatDelivery)
                      .map(item => {
                        return (
                          <li className="pickup">
                            <span>{item.description}</span>
                            <span>x{item.qty}</span>
                          </li>
                        );
                      })}
                  </ul>
                </>
            }
          </div>
          {fnbDataForTicketSummary?.filter(item => item.pickupAtCounter && !item.inSeatDelivery).length > 0 && (
            <div className="delivery-type-card-content to-be-picked-up-container">
              <p className="delivery-note to-be-picked-up">- Pick-up required at counter -</p>
              <ul className="to-be-picked-up-items-list" style={{ '--list-item-icon': "url('/assets/images/pick-up-list-item-icon.png')" }}>
                {fnbDataForTicketSummary
                  ?.filter(item => item.pickupAtCounter && !item.inSeatDelivery)
                  .map(item => {
                    return (
                      <li className="pickup">
                        <span>{item.description}</span>
                        <span>x{item.qty}</span>
                      </li>
                    );
                  })}
              </ul>
              <p className="note">*These items require counter pick-up only</p>
            </div>
          )}
        </div>
        <button className="btn btnPrimary proceed-btn" disabled={!selectedDeliveryType || isLoading} onClick={() => handleDeliveryTypeSelection(selectedDeliveryType)}>
          Yes, Proceed
        </button>
      </section>
    </div>
  );
};

export default DeliveryType;
